import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      inEditFlag: false,
      editedItem: {},
      modal: {
        detail: false
      },
      mobileColumns: ["", ""],
      columns: ["E-mail", "Comissão", "Validade do contrato", "Status", ""],
      actions: [
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        }
      ]
    };
  },
  computed: {
    ...mapState("user", ["coproducers", "pagination"]),
    ...mapState("product", ["product"])
  },
  filters: {
    formatTime(contract_time) {
      if (contract_time) {
        return `${moment(contract_time, "YYYY-MM-DD").format("DD/MM/YYYY")}`;
      }

      return "10 anos";
    },
    formatCoProducerStatus(status) {
      const status_map = {
        active: "Ativo",
        cancelled: "Inativo",
        rejected: "Rejeitado",
        waiting_validation: "Aguardando Aprovação",
        pendent: "Pendente"
      };

      return status_map[status];
    }
  },
  methods: {
    getChangeStatus(item) {
      return {
        text: item.status === "active" ? "Desativar coprodutor" : "Ativar",
        class: item.status === "active" ? "text-danger" : "text-success",
        icon: "icon-power",
        confirmation: {
          enable: true,
          text: `Deseja mesmo ${
            item.status === "active" ? "desativar" : "ativar"
          } este coprodutor?`,
          newDesign: item.status === "active" ? true : false,
          submitText:
            item.status === "active"
              ? "Desativar coprodutor"
              : "Ativar coprodutor",
          submitButtonClass:
            item.status === "active" ? "btn-danger" : "btn-primary"
        },
        event: "changeStatus"
      };
    },
    dispatch(product_id) {
      this.loading = true;
      this.$store
        .dispatch("user/getCoProducerByProduct", { id: product_id })
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    search(search) {
      this.loading = true;
      this.$store
        .dispatch("user/getCoProducerByProduct", {
          id: this.product.product_id,
          search
        })
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.dispatch(this.product.id);
    },
    edit(item) {
      this.inEditFlag = true;
      this.editedItem = item;
      this.modal.detail = true;
    },
    submitChangeStatus(item) {
      this.$store
        .dispatch("user/putCoProducerProduct", {
          id: item.id,
          co_producer_id: item.co_producer.id,
          product_id: this.product.id,
          contract_time: item.contract_time,
          payment_recurrence: item.payment_recurrence,
          tax_product: item.tax_product,
          status: item.status === "active" ? "cancelled" : "active"
        })
        .then(() => {
          this.$message.success(
            `A coprodução foi ${
              item.status === "active" ? "cancelada" : "ativada"
            }!`
          );
        })
        .catch(error => {
          this.$message.error(
            `Não foi possível ${
              item.status === "active" ? "cancelar" : "ativar"
            } a coprodução.`
          );
        })
        .finally(this.refresh);
    }
  }
};
